module.exports = __webpack_public_path__ + "static/media/close-1.ee45ea91.svg";